import { useCallback } from 'react';
import { employeeDeductionsService } from '../services';
import {
  useResourceCollection,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { EmployeeDeduction } from '../types';

export function useEmployeeDeductions(
  options?: ResourceQueryOptions
): ResourceState<EmployeeDeduction> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      employeeDeductionsService.getAll(opts) as unknown as Promise<{ data: EmployeeDeduction[]; meta?: any }>,
    []
  );
  return useResourceCollection<EmployeeDeduction>(fetchFn, options);
}

export function useCreateEmployeeDeduction(
  onSuccess?: (data: EmployeeDeduction) => void
): MutationState<EmployeeDeduction> {
  const createFn = useCallback(
    (data: any) => employeeDeductionsService.create(data) as unknown as Promise<EmployeeDeduction>,
    []
  );
  return useCreateResource<EmployeeDeduction>(createFn, onSuccess);
}

export function useUpdateEmployeeDeduction(
  onSuccess?: (data: EmployeeDeduction) => void
): MutationState<EmployeeDeduction> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
      return employeeDeductionsService.update(numericId, data) as unknown as Promise<EmployeeDeduction>;
    },
    []
  );
  return useUpdateResource<EmployeeDeduction>(updateFn, onSuccess);
}

export function useDeleteEmployeeDeduction(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return employeeDeductionsService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
